<template lang="html">
	<div class="sub-main column relative">
    <div class="sub-nav documents row">
			<nav>
				<router-link :to="{ name: item.uri }" class="item" v-for="item in menu" v-bind:key="item.key">
					{{ item.name }}
				</router-link>
			</nav>
    </div>
		<force-complete-profile-banner v-if="isForceCompleteProfile"/>
		<no-estate-short v-else-if="!isEstate"/>
		<patrimonial-short :white="true" />
		<div class="sub-page documents column take-place">
			<router-view></router-view>
		</div>
		<div v-if="isAnonymous" class="restricted-access column">
			<div class="title">
				Complétez votre inscription pour bénéficier<br/>
				de toutes les fonctionnalités Patrimoffice
			</div>
			<div class="subtitle">
				Ainsi que d'un essai gratuit d'un mois
			</div>
			<router-link class="btn btn-red" :to="{ name: 'AnonymousUpgrade' }">
				Compléter mon inscription <i class="icon-arrow-full-right"></i>
			</router-link>
		</div>
  </div>
</template>

<script>
import PatrimonialShort from '@/components/PatrimonialShort'
import NoEstateShort from '@/components/NoEstateShort'
import { mapGetters } from 'vuex'
import ForceCompleteProfileBanner from '@/components/ForceCompleteProfileBanner'

export default {
	name: 'Investments',
	components: {
		PatrimonialShort,
		NoEstateShort,
		ForceCompleteProfileBanner
	},
	data () {
		return {
			menu: [
				{
					key: 0,
					name: 'Synthèse',
					uri: 'Synthesis'
				}
				//				{
				//					key: 1,
				//					name: 'Historique',
				//					uri: 'History'
				//				}
			]
		}
	},
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous',
			isEstate: 'isEstate',
			isForceCompleteProfile: 'isForceCompleteProfile'
		})
	}
}
</script>

<style lang="scss" scoped>
	.relative {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/views/Investments/index.vue